import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { colors, fonts } from '../../ui';

// Contrast results graph (Figma session/14 right). Series colours are a validated categorical set
// (dataviz validator: lightness, chroma, CVD and contrast all pass on white): brand teal, amber, purple.
export const CS_SERIES = [
  { key: 'Right', color: '#0E9AA7' },
  { key: 'Left', color: '#D97706' },
  { key: 'Binocular', color: '#4A3AFF' },
];

const axis = { fontSize: 12, fill: colors.slate[500], fontFamily: fonts.family };

const CSGraphResults = ({ results }) => (
  <ResponsiveContainer width='100%' height='100%'>
    <LineChart data={results} margin={{ top: 12, right: 24, left: 0, bottom: 8 }}>
      <CartesianGrid vertical={false} stroke={colors.slate[200]} />
      <XAxis dataKey='name' tick={axis} axisLine={{ stroke: colors.slate[300] }} tickLine={false} />
      <YAxis tick={axis} axisLine={false} tickLine={false} width={40} />
      <Tooltip
        contentStyle={{ fontFamily: fonts.family, fontSize: 13, borderRadius: 8, border: `1px solid ${colors.slate[200]}`, color: colors.text }}
        labelFormatter={(l) => `logMAR ${l}`}
      />
      <Legend iconType='circle' wrapperStyle={{ fontFamily: fonts.family, fontSize: 13 }} formatter={(value) => <span style={{ color: colors.slate[600] }}>{value}</span>} />
      {CS_SERIES.map(({ key, color }) => (
        <Line key={key} type='monotone' dataKey={key} stroke={color} strokeWidth={2} dot={{ r: 4, strokeWidth: 2, fill: '#fff' }} activeDot={{ r: 6 }} connectNulls />
      ))}
    </LineChart>
  </ResponsiveContainer>
);

export default CSGraphResults;
